import { Column } from '@/shared/ui/data/EditableGrid/types/column.types';
import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { useGridTheme } from '@/shared/ui/data/EditableGrid/theme';

interface IProps {
  columns: ReadonlyArray<Column>;
  children: ReactNode;
  allowCopySelect?: boolean;
}

export function GridContainer({ columns, children, allowCopySelect }: IProps) {
  const { getContainerSx } = useGridTheme();
  const gridTemplateColumns = columns.map((col) => col.width ?? '1fr').join(' ');

  return (
    <Box className="grid-container" sx={getContainerSx(gridTemplateColumns, allowCopySelect)}>
      {children}
    </Box>
  );
}
